export enum LoanPropertyPurposeType {
    NonAcquisition = 0,
    Acquisition = 1,
    Refinance = 2,
    BuildRent = 3,
    FixRent = 4,
}
